<template>
    <div class="top-title">
        <div class="item i-left">
            <slot name="topLeft"></slot>
        </div>
        <div class="center">
            {{ title }}
        </div>
        <div class="item i-right">
            {{ nowDate + ' ' + nowWeek + ' ' + nowTime }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '移动能源运营监控调度大屏'
        }
    },
    data() {
        return {
            nowDate: "",    // 当前日期
            nowTime: "",    // 当前时间
            nowWeek: "",    // 当前星期
        }
    },
    mounted() {
        this.currentTime()
    },
    methods: {
        currentTime() {
            setInterval(this.getDate, 60);
        },
        getDate: function() {
            var _this = this;
            let yy = new Date().getFullYear();
            let mm = new Date().getMonth() + 1;
            let dd = new Date().getDate();
            let week = new Date().getDay();
            let hh = new Date().getHours();
            let mf =
                new Date().getMinutes() < 10
                    ? "0" + new Date().getMinutes()
                    : new Date().getMinutes();
            if (week == 1) {
                this.nowWeek = "星期一";
            } else if (week == 2) {
                this.nowWeek = "星期二";
            } else if (week == 3) {
                this.nowWeek = "星期三";
            } else if (week == 4) {
                this.nowWeek = "星期四";
            } else if (week == 5) {
                this.nowWeek = "星期五";
            } else if (week == 6) {
                this.nowWeek = "星期六";
            } else {
                this.nowWeek = "星期日";
            }
            _this.nowTime = hh + ":" + mf;
            _this.nowDate = yy + "年" + mm + "月" + dd +"日";
        }
    }
}
</script>

<style lang="scss" scoped>
.top-title {
    width: 100%;
    height: 150px;
    background: url(~@/assets/images/energyMuseum/top.png) top center;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    position: relative;
    .center {
        width: 680px;
        flex-shrink: 0;
        font-size: 46px;
        font-weight: bold;
    }
    .item {
        flex: 1;
        font-size: 24px;
        // box-sizing: border-box;
        // &.i-right {
        //     padding-right: 20%;
        // }
    }
}
</style>